import React from "react";
import { ColCard, Row } from "../../components/ContentLayout";
import PurchaseSalesPieChart from "../../components/Dashboard/PurchaseSalesPieChart";
import SalesBarChart from "../../components/Dashboard/SalesBarChart";

const StatisticsBoard = () => {
  return <>
    <Row>
      <ColCard
        type="light"
        md="12"
      >
        <SalesBarChart />
      </ColCard>
      {/* <ColCard
        type="light"
        md="6"
      >
        <SalesBarChart dataKey="SALES_CHART_DATAS2" title="전년대비 매출" />
      </ColCard> */}
      <ColCard
        type="light"
        md="12"
      >
        <PurchaseSalesPieChart />
      </ColCard>
    </Row>
  </>
}

export default StatisticsBoard